import type { IconName } from '@/components/ui/icon';

/**
 * Mobile bottom-tab configuration — the single source of truth for which
 * routes have a bottom-tab.
 *
 * This is a PLAIN module (no `'use client'`) on purpose: `Header` is a Server
 * Component and imports `MOBILE_TAB_HREFS` to drop these routes from the mobile
 * drawer. A runtime value exported from a `'use client'` module is replaced by
 * a client-reference proxy on the server (it loses its array methods), so
 * `MOBILE_TAB_HREFS.includes(...)` threw "is not a function" during render in
 * the production build. Keeping the value in a server-safe module fixes that;
 * the client action bar imports the same items.
 */
export const MOBILE_TAB_ITEMS: { href: string; labelKey: string; icon: IconName }[] = [
  { href: '/recipes', labelKey: 'recipes', icon: 'chef' },
  { href: '/cookbook', labelKey: 'cookbook', icon: 'book' },
  { href: '/meal-plan', labelKey: 'mealPlan', icon: 'calendar' },
  { href: '/shopping-list', labelKey: 'shopping', icon: 'cart' },
];

/** Routes that already have a bottom-tab — the mobile drawer skips these so it
 *  doesn't duplicate the action bar. */
export const MOBILE_TAB_HREFS: readonly string[] = MOBILE_TAB_ITEMS.map((i) => i.href);
